<template>
  <CoreDialog
    v-model="isOpened"
    data-qa="banner-mt-link-modal"
    :size="isMobile ? 'fullscreen' : 'xl'"
    persistent
  >
    <template #prependBtn="{ btnProps }">
      <v-btn
        v-bind="btnProps"
        @click="close"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>

    <BannerMtLinkSlider
      class="pb-2"
      :slides="slides"
      :is-mobile="isMobile"
    />

    <template
      v-if="isMobile"
      #actions
    >
      <div class="d-flex flex-column ga-2 flex-grow-1">
        <v-btn
          data-qa="modal-actions-btn-confirm"
          color="primary"
          block
          depressed
          @click="installApp"
        >
          {{ translate('Установить приложение') }}
        </v-btn>
        <v-btn
          data-qa="modal-actions-btn-close"
          color="primary"
          block
          text
          @click="close"
        >
          {{ translate('Закрыть') }}
        </v-btn>
      </div>
    </template>
  </CoreDialog>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import i18next from 'i18next'
import useIsMobile from 'src/composables/useIsMobile'
import useYandexGoals from 'src/composables/useYandexGoals'
import useContextStore from 'src/store/useContextStore'
import type { CommonContextStore } from 'src/types/context'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import { MEDTOCHKA_APP_STORE } from 'src/components/common/BannerMtLink/constants'
import getBannerMtLinkSlides from 'src/components/common/BannerMtLink/functions/getBannerMtLinkSlides'
import BannerMtLinkSlider from 'src/components/common/BannerMtLink/components/BannerMtLinkSlider.vue'

type Emits = {
  (_event: 'close'): void
}

const emit = defineEmits<Emits>()
const { t, language } = i18next
const l10nOptions = { ns: language }
const translate = (key: string) => t(key, l10nOptions) || key
const isMobile = useIsMobile()
const { context }: CommonContextStore = useContextStore()
const { sendYaGoal } = useYandexGoals()
const isOpened = ref(true)
const staticSrc = computed(() => context.global?.static?.src || '/static/')
const slides = computed(() => getBannerMtLinkSlides({
  translate,
  staticSrc: staticSrc.value,
  isMobile: isMobile.value,
}))

function close() {
  isOpened.value = false
}

watch(isOpened, value => {
  if (!value) {
    emit('close')
  }
})

function getAppStoreUrl() {
  if (process.env.IS_CLIENT && /iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    return MEDTOCHKA_APP_STORE.ios
  }

  return MEDTOCHKA_APP_STORE.android
}

function installApp() {
  if (process.env.IS_CLIENT) {
    window.open(getAppStoreUrl(), '_blank')
  }

  sendYaGoal('mtlinkModal__installApp')
}
</script>
